import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import { useVuelidate } from "@vuelidate/core";
import { futureDate, withValidDate } from "@Shared/@Utils/validation-rules";
import { maxValue } from "@vuelidate/validators";
import { minValueNotRequired } from "@Shared/@Utils/new-validation-rules";
import { computed } from "@vue/composition-api";
import { useSubjectPropertyFieldBindings } from "@Client/@Composables/application-standalone/pages/subject-property/useSubjectPropertyFieldBindings";
import { useSubjectPropertyHelpers } from "../pages/subject-property/useSubjectPropertyHelpers";
import { getValidationRulesFromMap } from "@Client/@Composables/application-standalone/validations/getValidationRulesFromMap";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { camelCase, capitalize, mapKeys } from "lodash";
export const subjectPropertyExistingMortgageValidator = (existingMortgageIndex, {
  lazy = false
} = {}) => {
  const {
    existingMortgageBalanceRemaining,
    existingMortgageBlendedAmortization,
    existingMortgageCurrentMortgageNumber,
    existingMortgageFrequency,
    existingMortgageInsured,
    existingMortgageInterestRate,
    existingMortgageLender,
    existingMortgageLoanType,
    existingMortgageMaturityDate,
    existingMortgageMortgageInsuranceProviderId,
    existingMortgageMortgageType,
    existingMortgageOrigAmount,
    existingMortgagePaymentAmount,
    existingMortgagePayoff,
    existingMortgageRateType,
    existingMortgageTermType,
    existingMortgageRefiAdditionalInfo,
    existingMortgageInsuranceAccountNumber
  } = useSubjectPropertyFieldBindings({
    existingMortgageIndex
  });
  const {
    GET_SCHEMA_RULES_BY_PATH,
    PROPERTY_REQUESTED,
    HAS_CONSOLIDATED_REQUEST
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH, ApplicationStandaloneGetters.HAS_CONSOLIDATED_REQUEST, ApplicationStandaloneGetters.PROPERTY_REQUESTED]);
  const rules = computed(() => {
    return getValidationRulesFromMap(() => !HAS_CONSOLIDATED_REQUEST.value || PROPERTY_REQUESTED.value, GET_SCHEMA_RULES_BY_PATH, existingMortgagePageRules, "property", {
      "existing-mortgages": existingMortgageIndex.value
    });
  });
  const v$ = useVuelidate(rules, {
    existingMortgageBalanceRemaining,
    existingMortgageBlendedAmortization,
    existingMortgageCurrentMortgageNumber,
    existingMortgageFrequency,
    existingMortgageInsured,
    existingMortgageInterestRate,
    existingMortgageLender,
    existingMortgageLoanType,
    existingMortgageMaturityDate,
    existingMortgageMortgageInsuranceProviderId,
    existingMortgageMortgageType,
    existingMortgageOrigAmount,
    existingMortgagePaymentAmount,
    existingMortgagePayoff,
    existingMortgageRateType,
    existingMortgageTermType,
    existingMortgageInsuranceAccountNumber,
    existingMortgageRefiAdditionalInfo
  }, {
    $scope: true,
    $lazy: lazy
  });
  return {
    v$
  };
};
const existingMortgagePageRules = {
  existingMortgageBalanceRemaining: {},
  existingMortgageBlendedAmortization: {},
  existingMortgageCurrentMortgageNumber: {},
  existingMortgageFrequency: {},
  existingMortgageInsured: {},
  existingMortgageInterestRate: {},
  existingMortgageLender: {},
  existingMortgageLoanType: {},
  existingMortgageMaturityDate: {
    futureDate: () => futureDate,
    withValidDate: () => withValidDate
  },
  existingMortgageMortgageInsuranceProviderId: {},
  existingMortgageMortgageType: {},
  existingMortgageOrigAmount: {
    minValue: required => minValueNotRequired(100, required),
    maxValue: maxValue(1000000000000)
  },
  existingMortgagePaymentAmount: {},
  existingMortgagePayoff: {},
  existingMortgageRateType: {},
  existingMortgageTermType: {},
  existingMortgageInsuranceAccountNumber: {},
  existingMortgageRefiAdditionalInfo: {}
};
export const subjectPropertyExistingMortgagesValidator = ({
  lazy = false
} = {}) => {
  const {
    allSubjectPropertyExistingMortgages
  } = useSubjectPropertyHelpers();
  const allExistingMortgages = computed(() => {
    var _allSubjectPropertyEx, _allSubjectPropertyEx2;
    const mappedKeys = (_allSubjectPropertyEx = (_allSubjectPropertyEx2 = allSubjectPropertyExistingMortgages.value) == null ? void 0 : _mapInstanceProperty(_allSubjectPropertyEx2).call(_allSubjectPropertyEx2, item => mapKeys(item, (_value, key) => camelCase("existingMortgage" + capitalize(key))))) != null ? _allSubjectPropertyEx : [];
    return mappedKeys;
  });
  const {
    GET_SCHEMA_RULES_BY_PATH,
    PROPERTY_REQUESTED
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH, ApplicationStandaloneGetters.PROPERTY_REQUESTED]);
  const rules = computed(() => {
    var _context;
    const objectRules = index => getValidationRulesFromMap(() => PROPERTY_REQUESTED.value, GET_SCHEMA_RULES_BY_PATH, existingMortgagePageRules, "property", {
      "existing-mortgages": index
    });
    return _reduceInstanceProperty(_context = allExistingMortgages.value).call(_context, (acc, _applicant, index) => {
      acc[index] = objectRules(index);
      return acc;
    }, {});
  });
  const v$ = useVuelidate(rules, allExistingMortgages, {
    $scope: "subjectProperty",
    $lazy: lazy
  });
  return {
    v$
  };
};